import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper'
import { useStyles } from "../hooks/useStyles";
import { useFormats } from "../hooks/useSkuUtils";
import { useOrderItemChangeHandlers } from "../hooks/useUtils";
import { InputDynamicText } from '../components/InputDynamicText';
import { showRoundedAbsAmt, findAbsAmtAsPct,
          } from '../utils';
import { OutlayAmt } from '../components/OutlayAmt';
import AdminChangeOtherOrder from './AdminChangeOtherOrder'

//import { useTranslation } from "react-i18next";

export const OthersOrders = ({
    if_shopper_is_circle_admin,
    order,
    trip,
    sku,
    inCartStatus,
    actualWeight,
    othData,
    skuPrice
   }) => {
  console.log("ooB sku", sku)
  console.log("ooC skuPrice", skuPrice)
  // FIX ME: need to use signedIn or shopper here?
  const { orderItems, showOutlayWithTax, showOthersZeroOrders,
          showSlimShopList,
          showOthersOrders,
        } = useContext(ShopperContext);
  console.log("ooD orderItems", orderItems)
  console.log("ooE showOthersZeroOrders", showOthersZeroOrders)
  //const { t } = useTranslation();
  const { textAlignRight } = useStyles();
  const { spaceUnits,
        } = useFormats();
  const { handleMinMaxNoteClick } = useOrderItemChangeHandlers();

  const othersRows =
    othData.map((othd) => {
      // 'othd' is an object holding another CircleShopper's:
      // othShopperOrderItem: othShopperOrderItem,
      // othAbsAmt: othAbsAmt,
      // unitQty: unitQty,
      // adjustedAbsAmtAsPct: adjustedAbsAmtAsPct,

    return (
    <tr key={'oo' + othd.othShopperOrderItem.id}>
    {showSlimShopList
    ? null
    : <>
      <td className="ellipsis">
        {/* ID */}
        {sku.identifier}
      </td>

      <td> </td>
        {/* Brand */}
    </>
    }
      <td> </td>
        {/* Name/Label */}

    {showSlimShopList
    ? null
    :
      <td>
        {/* Store */}
      </td>
    }

    {showOthersOrders
    ?
      <td className='fw-bold'>
        {/* Who */}
        { othd.othShopperOrderItem.shopper.shortname }
      </td>
    : null
    }

    {showSlimShopList
    ? null
    :
      <td>
        {/* "Unit Count" || Sku has this many units */}
      </td>
    }

      <td>
        {/* Price */}
      </td>

      {
        (if_shopper_is_circle_admin)
          ? <AdminChangeOtherOrder
              order={othd.othShopperOrderItem}
              skuPrice={skuPrice}
              actualWeight={actualWeight}
              trip={trip}
              sku={sku}
            />
          :
            <>
    {showSlimShopList
      ? null
      : <>
              <td>
                {/* "UnitQty" - add sku.units (e.g. 'lb') if sku isWeighty */}
                {othd.unitQty}
                {sku.type === "WeightyItem"  &&  spaceUnits({units: sku.units})}
              </td>
        
              <td>
                {/* "Unit Cost" */}
              </td>
        </>
    }
        
              <td style={textAlignRight}>
                {/* "%Wantd" */}
                {showRoundedAbsAmt({ 
                                  adjustedAbsAmtAsPct: othd.adjustedAbsAmtAsPct
                                      }) + "%"}
              </td>

    {showSlimShopList
      ? null
      : <>
              <td>
                {/*  #-#  */}
                <InputDynamicText
                  initialText = {othd.othShopperOrderItem.min_max_note || ''}
                  handleTextClick =
                            {handleMinMaxNoteClick(othd.othShopperOrderItem.id)}
                  placeholder = ''
                />
              </td>
        
              <td>
               <div className = "oneline-container-right">
                <OutlayAmt
                  trip        = {trip}
                  sku         = {sku}
                  sku_price   = {skuPrice}
                  order       = {othd.othShopperOrderItem}
                  decimal_amt = {
                            findAbsAmtAsPct({topNum: othd.othAbsAmt, sku}) /100
                                }
                  showOutlayWithTax = {showOutlayWithTax}
                />
               </div>
              </td>
        
              <td>
                {/* "O" button: */}
              </td>
        </>
    }
            </>
      }

      <td>
        {/* adjustedCircleAmt */}
      </td>

    {showSlimShopList
    ? null
    : <>
      <td>
        {/* circleOutlay */}
      </td>

      <td>
        {inCartStatus}
      </td>
    </>
    }

    </tr>
        )
      })

  console.log("ooH othersRows", othersRows);
  return  othersRows.length > 0  ?  othersRows  :  null;
      };

export default OthersOrders;